export const CreditorPortalNote = {
  initFormData: {
    note: "",
    noteCategoryId: "",
  },
  isSending: false,
};

const Category = {
  noteCategoryId: 0,
  categoryName: "",
  displayName: "",
};

export const CreditorNoteCategory = {
  data: [Category],
  isLoading: false,
};
